<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.7085 6.33341H7.79183L4.87516 3.41675L1.9585 6.33341H4.04183V14.6667H1.9585L4.87516 17.5834L7.79183 14.6667H5.7085V6.33341ZM9.04183 4.66675V6.33341H19.0418V4.66675H9.04183ZM9.04183 16.3334H19.0418V14.6667H9.04183V16.3334ZM9.04183 11.3334H19.0418V9.66675H9.04183V11.3334Z" />
</svg>
